import { render, staticRenderFns } from "./TicketPlantDetail.vue?vue&type=template&id=72fa2fa6&"
import script from "./TicketPlantDetail.vue?vue&type=script&lang=js&"
export * from "./TicketPlantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports